import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators, FormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { DialogPromoComponent } from '../_dialoghi/dialog-promo/dialog-promo.component';
import { AppoggioService } from '../_servizi/appoggio.service';
import { CantinaService } from '../_servizi/cantina.service';
import { CarrelloViniService } from '../_servizi/carrelloVini.service';
import { LoaderService } from '../_servizi/loader.service';
import { MessageServiceService } from '../_servizi/message-service.service';
import { PromoService } from '../_servizi/promo.service';
import { StepService } from '../_servizi/step.service';
import { StripeService } from '../_servizi/stripe.service';
import { VisiteService } from '../_servizi/visite.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-step1-regalo',
  templateUrl: './step1-regalo.component.html',
  styleUrls: ['./step1-regalo.component.css']
})
export class Step1RegaloComponent implements OnInit {

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  isLoading: Subject<boolean> = this.loaderService.isLoading;

  codiceForm: any;
  idTipoVisita: any;
  linguaCorrente: string;

  adulti = 1;

  form: UntypedFormGroup;
  messaggioFormControl = new FormControl('', [Validators.maxLength(160)]);
  ricercaFatta = false;
  cantina: any;
  nessunavisita = false;
  denominazione: any;
  tipovisita = null;

  showNote = false;
  showTermini = false;

  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    public loaderService: LoaderService,
    private stepService: StepService,
    private cantinaService: CantinaService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    public carrelloService: CarrelloViniService,
    private messageService: MessageServiceService,
    private appoggioService: AppoggioService,
    private stripeService: StripeService,
    private visiteService: VisiteService
  ) {
    this.stepService.currentStep = 1;

    this.form = this.fb.group({
      messaggio: this.messaggioFormControl
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.codiceForm = params.get('cantina');
      this.idTipoVisita = params.get('visita');
      this.linguaCorrente = params.get('lingua');

      this.translate.use(this.linguaCorrente);

      this.getInfoCantina(this.codiceForm);

      let idCookie = params.get('idCookie');

      if (idCookie && idCookie !== 'null' && idCookie !== undefined && idCookie !== 'undefined') {
        this.messageService.setIdCookie(idCookie);
      } else {
        idCookie = uuidv4();
        this.messageService.sendIdCookie(idCookie);
        this.messageService.setIdCookie(idCookie);
      }
    });
  }

  getInfoCantina(codiceForm): void {
    this.cantinaService.getStato(codiceForm)
      .subscribe(cantina => {
        this.loading = true;
        this.checkAbilitato = true;
        if (cantina && cantina.length > 0) {
          this.stepService.cantinaDenominazione = cantina[0].denominazione;
          const clientUrl = document.referrer;

          this.abilitato = true;
          this.getDetteglioVisitaRegalo(this.linguaCorrente, this.codiceForm, this.idTipoVisita);

          if (cantina[0]['infoStripe'] != null) {
            const infoStripe = {
              abilitatoAccount: cantina[0]['infoStripe']['abilitatoAccountStripe'] === '1' ? true : false,
              abilitatoProduzione: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? true : false,
              api_key: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? cantina[0]['infoStripe']['apiKeyStripeProduzione'] : cantina[0]['infoStripe']['apiKeyStripeTest'],
              endpoint_secret: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? cantina[0]['infoStripe']['endpointSecretProduzione'] : cantina[0]['infoStripe']['endpointSecretTest']
            }
            this.stripeService.setInfoStripe(infoStripe);
          } else {
            this.stripeService.setInfoStripe(null);
          }
          this.appoggioService.setColoriIframe(cantina[0]);
        } else {
          this.abilitato = false;
          this.nonabilitatoMsg = 'nonAbilitato';
          this.loading = false;
        }
      });
  }

  getDetteglioVisitaRegalo(lingua, codiceForm, idTipoVisita): void {
    this.loading = true;
    this.visiteService.getVisitaRegaloDetails(lingua, codiceForm, idTipoVisita)
      .subscribe(cantina => {
        this.ricercaFatta = true;
        if (cantina.tipovisita) {
          this.cantina = cantina.info;
          this.tipovisita = cantina.tipovisita
          this.stepService.richiediDatiFiscaliRicevuta = this.cantina.richiediDatiFiscaliRicevuta === '1' ? true : false;

          this.adulti = parseInt(this.tipovisita.defaultMin, 10);

          this.cantina.lat = parseFloat(this.cantina.lat);
          this.cantina.lng = parseFloat(this.cantina.lng);
        } else {
          this.nessunavisita = true;
          this.denominazione = cantina.info.denominazione;
        }
        this.loading = false;
      });
  }

  adultiMeno() {
    const multipli = parseInt(this.tipovisita.defaultMultipli, 10);
    const min = parseInt(this.tipovisita.defaultMin, 10);

    if (this.adulti - multipli >= min) {
      this.adulti -= multipli;
    }
  }

  adultiPiu() {
    const multipli = parseInt(this.tipovisita.defaultMultipli, 10);
    const max = parseInt(this.tipovisita.defaultMax, 10);

    if (this.adulti + multipli <= max) {
      this.adulti += multipli;
    }
  }

  gestisciAzioneContinua() {
    const valori = {
      idClientiMaster: this.cantina.id,
      codiceFormMaster: null,
      idCliente: null,
      idTipoVisita: this.tipovisita.idTipoVisita,
      durata: this.tipovisita.duratagg,
      tiporegala: this.tipovisita.tiporegala,
      fineregala: this.tipovisita.fineregala,
      npersone: this.adulti,
      totale: this.totale,
      nominativo: null,
      nome: null,
      email: null,
      messaggio: this.form.value.messaggio,
      dataRegaloAttiva: false,
      dataRegaloInvio: null,
      pacchetti: null
    };

    this.carrelloService.addCarrello("carrelloBuonoCantina", valori).subscribe(result => {
      if (result['risultato']) {
        this.router.navigate(['/step2/' + this.messageService.getIdCookie() + '/' + this.translate.currentLang]);
      }
    });
  }

  terminiOrNote() {
    let ris = false;
    if ((this.cantina.note_base && this.cantina.note_base.length > 1) || (this.cantina.termini_cancellazione && this.cantina.termini_cancellazione.length > 1)) {
      ris = true;
    }
    return ris;
  }

  showPopUp(scelta) {
    switch (scelta) {
      case 1:
        this.showNote = this.showNote ? false : true;
        this.showTermini = false
        break;
      case 2:
        this.showTermini = this.showTermini ? false : true;
        this.showNote = false
        break;
    }
  }

  get totale() {

    const przVisita = parseFloat(this.tipovisita.maxPrz);

    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(this.tipovisita.costoDefault);
    }

    return przOk * this.adulti;
  }
}
